const styles = theme => ({
  box: {
    margin: 15,
    padding: 10,
    border: "1px solid #e1e1e1",
    boxShadow: "0 3px 6px rgba(0, 0, 0, .2)",
    borderRadius: 5,
    height: "325px",

    "& h4": {
      marginBottom: 10,

      "& a": {
        overflow: "hidden",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        fontWeight: "600",

        "&:hover": {
          color: theme.colors.primary
        }
      }
    },

    "& h5": {
      overflow: "hidden",
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      color: "#555"
    }
  },
  boxImg: {
    overflow: "hidden",
    marginBottom: 10,
    borderRadius: 5,

    "& img": {
      transition: ".3s",
      height: 200,
      objectFit: "cover",
      width: "100%"
    },

    "&:hover img": {
      transform: "scale(1.2)"
    }
  },
  boxPage: {
    width: "calc(100% / 3 - 30px)",
    margin: 15,
    padding: 10,
    border: "1px solid #e1e1e1",
    boxShadow: "0 3px 6px rgba(0, 0, 0, .2)",
    borderRadius: 5,

    "& h4": {
      marginBottom: 10,

      "& a": {
        overflow: "hidden",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        fontWeight: "600",

        "&:hover": {
          color: theme.colors.primary
        }
      }
    },

    "& h5": {
      overflow: "hidden",
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      color: "#555"
    }
  },
  // Mobile
  [theme.breakpoints.down("sm")]:{
    boxPage: {
      width: "calc(100% /2 - 30px)",
    },

    boxImg: {
      "& img": {
        height: "150px"
      }
    },
  },

  [theme.breakpoints.down("xs")]:{
    boxPage: {
      width: "calc(100% - 30px)",
    },
    boxImg: {
      "& img": {
        height: "200px",
        objectFix: "cover"
      }
    },
  }
});

export default styles;
